import React from "react";
import CheckInsModule from "./checkInsModule";
import CheckInSagas from "./redux/checkInSaga";
import CheckInReducer from "./redux/checkInReducer";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Check Ins",
  moduleList: [
    {
      Component: CheckInsModule,
      moduleName: "checkIns",
      saga: CheckInSagas(),
      reducer: CheckInReducer
    }
  ],
  hideConfigurator: true
};

const CheckInsPage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default CheckInsPage;
